const initialState = {
  profile: {},
};

const editApplication = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_PROFILE':
      return {
        ...state,
        profile: action.data,
      };
    case 'SET_PROFILE':
      return {
        ...state,
        profile: action.data,
      };
    default:
      return state;
  }
};
export default editApplication;
